module.exports = __webpack_public_path__ + "img/lingxingxiaoding.prt.5a268649.jpg";